import React, { useState, useEffect } from 'react'
import Button from './../button/Button';
import { useSelector, useDispatch } from 'react-redux'
import removeIcon from './../../images/svg/remove-tag.svg';
import axios from 'axios';
import ApiUrl from './../../services/ApiUrl';
import Input from './../../components/input/Input';

const Tags = ( props ) => {
    let [ value, setValue ] = useState({
        value: '',
        id: 0,
    });
    let [ tagsPage, setTagsPage ] = useState([]);
    let [ allTags, setAllTags ] = useState([]);
    let pageID = typeof window !== "undefined" && (window.location.pathname).split("/");pageID = pageID[pageID.length -1]
    let [ resultChoose, setResultChoose ] = useState(false);
    let [ disableBtn, setDisableBtn ] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        if(props.page && props.page.tags) {
            getTagsPage(props.page.tags);
        }
    }, [props.page])

    useEffect(() => {
        if(props.languagePageID) {
            getTags();
        }
    }, [props.languagePageID])

    const getTags = () => {
        axios({
            method: 'get',
            url: `${ApiUrl()}/getTags?langID=${props.languagePageID}`,
            headers: { Authorization: `Bearer ${ localStorage.getItem('token') }` }
        }).then(response => {
            let res = JSON.parse(response.request.response);
            setAllTags(res)
        })
    }

    const getTagsPage = (data) => {
        let newTags = [];
        data && data.map(tag => {
            if(tag.data) {
                newTags = [...newTags, tag.data];
            }
        })
        setTagsPage(newTags);
    }

    const removeTag = (index) => {
        let removeTag = tagsPage[index];
        axios({
            method: 'post',
            url: `${ApiUrl()}/removeTagFromPage`,
            data: {
                tagID: removeTag.id,
                pageID: pageID,
                token: localStorage.getItem('token')
            },
        }).then(response => {
            let res = JSON.parse(response.request.response);
            //tags
            let tags = [];
            res.page.tags && res.page.tags.map(tag => {
                tags = [...tags, tag.data];
            })
            setTagsPage(tags);
        })
    }

    const checkResultChoose = (val) => {
        if(val.length > 2) {
            let result = [];
            allTags && allTags.map(tag => {
                if((tag.name).toLowerCase().substring(0, val.length) == val.toLowerCase()) {
                    result = [...result, tag];
                }
            })
            setResultChoose(result);
        }else{
            setResultChoose([]);
        } 
    }

    const addTag = () => {
        if(!disableBtn) {
            setDisableBtn(true);
            let errors = false;
            if(!value || value.value.length == 0) {
                dispatch({ type: 'NOTIFICATION_ALERT_TEXT', value: `<p>Należy wprowadzić nazwę tagu</p>` })
                errors = true;
            }
    
            if(errors) {
                setDisableBtn(false);
            }
    
            if(!errors) {
                axios({
                    method: 'post',
                    url: `${ApiUrl()}/newTagPage`,
                    data: {
                        tagID: value.id,
                        pageID: pageID,
                        newTagName: value.value,
                        langID: props.languagePageID,
                        userID: localStorage.getItem('userId'),
                        token: localStorage.getItem('token')
                    },
                }).then(response => {
                    let res = JSON.parse(response.request.response);
                    if(res.status == true) {
                        if(value.id == 0) {
                            let newAllTags = allTags;
                            newAllTags = [...newAllTags, res.tag];
                            setAllTags(newAllTags);
                            let dataTagsPage = tagsPage;
                            dataTagsPage = [...dataTagsPage, res.tag];
                            setTagsPage(dataTagsPage)
                        }else{
                            let dataTagsPage = tagsPage;
                            dataTagsPage = [...dataTagsPage, res.tag];
                            setTagsPage(dataTagsPage)
                        }

                        setValue({
                            value: '',
                            id: 0,
                        })
                        setDisableBtn(false);
                    }else{
                        dispatch({ type: 'NOTIFICATION_ALERT_TEXT', value: `<p>Coś poszło nie tak, prosimy spróbować ponownie później</p>` })
                        setDisableBtn(false);
                    }
    
                })
            }
        }
    }

    const saveChoose = (val) => {
        setValue(val); 
        setResultChoose(false);
    }

    const handleKeyDown = (e, functionName, functionValue = false, functionValueSecond = false) => {
        if (e.key === 'Enter') {
            functionName(functionValue, functionValueSecond)
        }
    }

    return (
        <div className="tags settings-box">
            <div className="header">
                <span>Tagi</span>
            </div>
            <div className="content">
                <div className="new-tag">
                    {/* <input class="input-tags" type="text" value={value.value} onChange={(e) => { setValue({value: e.target.value, id: value.id}); checkResultChoose(e.target.value) } } /> */}
                    <Input  required={ false }
                        setFunction={ val => { setValue({value: val, id: value.id}); checkResultChoose(val) } }
                        value={ value.value }
                        regExp={ /.*/ }
                        placeholder="nazwa"
                    />
                    <div className="result">
                        {resultChoose && resultChoose.map((res, index) => (
                            <div key={index} 
                                className="result-choose" 
                                role="button"
                                tabIndex="0"
                                onKeyPress={ (e) => handleKeyDown(e, saveChoose, {value: res.name, id: res.id})}
                                onClick={() => saveChoose({value: res.name, id: res.id}) }>
                                <p>{res.name}</p>
                            </div>
                        ))}
                    </div>
                    <div className="submit">
                        <Button title="Dodaj" setFunction={() => addTag()} />
                    </div>
                </div>
                <small>Dodawaj tagi pojedyńczo</small>
                <div className="tags">
                    {tagsPage && tagsPage.map((tag, index) => (
                        <div className="tag" 
                            onClick={() => removeTag(index)}
                            aria-label={`Usuń ${tag.name}`}
                            role="button"
                            tabIndex="0"
                            onKeyPress={ (e) => handleKeyDown(e, removeTag, index)}>
                            <p>{tag.name}</p>
                            <div className="remove">
                                <img src={removeIcon} alt="remove" />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Tags;
